import React from "react";
import { observer } from "mobx-react-lite";

import { BettingData } from "@data-types/sport-stats/SportStatsTypes";
import {
	CorrectScoreStatistics,
	DoubleChanceStatistics,
	OverUnderByPeriod,
	FirstTeamToScoreStatistics,
	HandicapStatistics,
	OverUnderStatistics,
	ThreeWayStatistics,
	WhoWinsFirstHalfStatistics,
	WhoWinsSecondHalfStatistics,
	WillBothTeamsScoreStatistics,
} from "@features/offer/shared/statistics/components/betting-types";
import { ErrorWrapper } from "@features/offer/shared/statistics";

type StatisticsComponentProps = {
	homeTeam: any;
	awayTeam: any;
};

const statisticsComponents: {
	[key: string]: React.ComponentType<StatisticsComponentProps>;
} = {
	"3way": ThreeWayStatistics,
	"double-chance": DoubleChanceStatistics,
	"over-under": OverUnderStatistics,
	"who-wins-1st-half": WhoWinsFirstHalfStatistics,
	"who-wins-2nd-half": WhoWinsSecondHalfStatistics,
	"will-both-teams-score": WillBothTeamsScoreStatistics,
	"handicap-hcp": HandicapStatistics,
	"correct-score-score-max-6": CorrectScoreStatistics,
	"1st-half-totals": OverUnderByPeriod,
	"2nd-half-over-under": OverUnderByPeriod,
	"goalnr-goal": FirstTeamToScoreStatistics,
};

export default observer(function BettingTypeStatistics(props: {
	bettingTypeStats: BettingData[] | null;
	bettingTypeAbrv: string;
}) {
	if (!props.bettingTypeStats || props.bettingTypeStats.length == 0) {
		return null;
	}

	const homeTeamData = props.bettingTypeStats?.[0]?.data;
	const awayTeamData = props.bettingTypeStats?.[1]?.data;

	const SpecificStatisticsComponent =
		statisticsComponents[props.bettingTypeAbrv];

	if (!SpecificStatisticsComponent) {
		return null;
	}

	return (
		<ErrorWrapper>
			<SpecificStatisticsComponent
				homeTeam={homeTeamData}
				awayTeam={awayTeamData}
			/>
		</ErrorWrapper>
	);
});
